import * as actions from './actions';
import { ADD_CLASS_SUCCESS, GET_CLASSROOMS_SUCCESS, DELETE_CLASSROOMS_SUCCESS } from '../class-roll/actions';
import { ADD_STUDENT_SUCCESS } from '../student-roll/actions';
import { QUICK_UPLOAD_CLOSE_MODAL_REQUEST } from '../quick-upload/actions';
import { CANCEL_USER_ASSIGN_REQUEST, ASSIGN_TEACHER_SUCCESS, RESET_USER_CLASSROOM_RELATION, ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS } from '../assign-user/actions';
import { EDIT_TEACHER_SUCCESS_REQUEST, REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST } from '../edit-teacher/actions';
import { UNASSIGN_TEACHER_SUCCESS } from '../edit-class/actions';
import messages from './messages';
import { getAlphaNumericCharacters, filterProductTeachers, updateClassroomList } from '../../helpers/utils';
import { filterTeachers, sort } from '../../helpers/grid-util';

const getTeacherLastNames = () => {
    const names = [{ key: '-1', value: messages.defaultOptionTeacherLastName, selected: true }];
    const namePrefixes = getAlphaNumericCharacters().split('').map(item => ({ key: item, value: item }));
    const allNamePrefixes = names.concat(namePrefixes);
    return allNamePrefixes;
};

const dataFilterOption = {
    lastNames: getTeacherLastNames(),
    classrooms: [{ key: '-1', value: messages.defaultOptionTeacherClass, selected: true },
        { key: 'classes', value: messages.UnassignedTeacher, selected: false }],
    searchTerm: '',
    sortColumn: 'lastName',
    sortDirection: 'asc'
};

const assignEmptyTeacherObject = () => (
    { firstName: '', lastName: '', classroomId: '-1', title: '', emailAddress: '', classrooms: [] }
);

const initState = {
    teachers: [],
    filteredTeachers: [],
    isTeacherDataLoaded: false,
    dataFilterOption,
    selectedTeachers: [],
    isSaveInProgress: false,
    teacherModel: assignEmptyTeacherObject(),
    teacherTitles: [
        { key: '', value: 'Title', selected: true },
        { key: 'Miss', value: 'Miss' },
        { key: 'Mr', value: 'Mr' },
        { key: 'Mrs', value: 'Mrs' },
        { key: 'Ms', value: 'Ms' },
        { key: 'Dr', value: 'Dr' }],
    lastAddedTeacherUserProfileId: 0,
    isSignInCardDownloaded: true,
    isUserOperationModalOpen: false,
    isEmailVerificationModalOpen: false,
    sendingEmailsResult: {
        totalRequests: 0,
        successfulSending: 0,
        alreadyVerifiedEmails: 0,
        duplicateEmails: 0,
        invalidRequests: 0
    },
    emailVerificationError: false,
    refreshTeacherList: false,
    disableConfirmationButtons: false,
    operationType: '',
    teachersFiltered: []
};

const updateEmptyTeacherModel = (classrooms) => {
    const classes = classrooms.map(item => ({
        key: item.classroomId,
        value: item.name
    }));

    return { ...assignEmptyTeacherObject(), classrooms: classes };
};

const resetSelectedItem = (items) => {
    const selectedItem = items.find(item => item.selected === true);
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

const resetFilterOptions = (currentOptions) => {
    const lastNames = resetSelectedItem(currentOptions.lastNames);
    const classrooms = resetSelectedItem(currentOptions.classrooms);

    return { ...currentOptions, lastNames, classrooms, searchTerm: currentOptions.searchTerm };
};

const getFilteredData = (teachers, filterOptions) => filterTeachers(teachers, filterOptions);

const getSortedData = (teachers, filterOptions) => sort(
    teachers,
    filterOptions.sortColumn,
    filterOptions.sortDirection);

const changeFilterOptions = (currentOptions, collectionName, key) => {
    const items = currentOptions[collectionName];
    const selectedItem = items.find(item => item.selected === true);
    selectedItem.selected = false;
    const newSelection = items.find(item => item.key.toString() === key);
    newSelection.selected = true;
    return { ...currentOptions, [collectionName]: currentOptions[collectionName] };
};

const sendVerificationEmailSuccess = (state, sendingEmailsResult) => (
    {
        ...state,
        isEmailVerificationModalOpen: true,
        emailVerificationError: false,
        sendingEmailsResult
    }
);

const sendVerificationEmailFailure = state => (
    { ...state, isEmailVerificationModalOpen: true, emailVerificationError: true }
);

const closeVerificationModal = state => (
    { ...state, isEmailVerificationModalOpen: false, selectedTeachers: [] }
);

export default function (state = initState, action) {
    switch (action.type) {
    case actions.GET_PRODUCT_TEACHERS_REQUEST: {
        return { ...state, isTeacherDataLoaded: false, teachers: [], filteredTeachers: [] };
    }
    case actions.GET_PRODUCT_TEACHERS_SUCCESS: {
        state.dataFilterOption.searchTerm = '';
        return { ...state,
            isTeacherDataLoaded: true,
            refreshTeacherList: false,
            teachers: action.data,
            filteredTeachers: action.data,
            teachersCount: action.data.length,
            teachersFiltered: filterProductTeachers(action.data),
            dataFilterOption: resetFilterOptions(state.dataFilterOption)
        };
    }
    case actions.DOWNLOAD_TEACHER_ROLL_REQUEST : {
        return { ...state, isTeacherRollDownloaded: action.isTeacherRollDownloaded };
    }
    case actions.DOWNLOAD_TEACHER_ROLL_SUCCESS: {
        return { ...state, isTeacherRollDownloaded: action.isTeacherRollDownloaded };
    }
    case actions.TEACHER_FILTER_VALUE_CLEARED: {
        const filterOption = resetFilterOptions(state.dataFilterOption);
        const filteredTeachers = getFilteredData(state.teachers, filterOption);
        return {
            ...state,
            filteredTeachers,
            dataFilterOption: filterOption,
            selectedTeachers: []
        };
    }
    case actions.TEACHER_FILTER_VALUE_CHANGED: {
        const filterOption = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
        const filteredTeachers = getFilteredData(state.teachers, filterOption);
        return {
            ...state,
            filteredTeachers,
            dataFilterOption: filterOption,
            selectedTeachers: []
        };
    }
    case actions.UPDATE_TEACHER_SEARCH_TERM: {
        const filterOption = { ...state.dataFilterOption, searchTerm: action.searchTerm };
        const filteredTeachers = getFilteredData(state.teachers, filterOption);
        return {
            ...state,
            filteredTeachers,
            dataFilterOption: filterOption,
            selectedTeachers: []
        };
    }
    case actions.SORT_TEACHER_LIST: {
        let sortDirection = 'asc';
        if (state.dataFilterOption.sortColumn === action.columnToSort) {
            if (state.dataFilterOption.sortDirection === 'asc') {
                sortDirection = 'desc';
            }
        }

        const filterOption = { ...state.dataFilterOption, sortColumn: action.columnToSort, sortDirection };
        const filteredTeachers = getSortedData(state.filteredTeachers, filterOption);
        return { ...state, filteredTeachers, dataFilterOption: filterOption };
    }
    case actions.RETRIEVE_SELECTED_TEACHER: {
        return { ...state, selectedTeachers: action.selectedTeachers };
    }
    case actions.UNASSIGN_TEACHERS_REQUEST: {
        return { ...state, disableConfirmationButtons: action.disableConfirmationButtons, selectedTeachers: [] };
    }
    case actions.UNASSIGN_TEACHERS_SUCCESS: {
        return {
            ...state,
            isUserOperationModalOpen: action.isUserOperationModalOpen,
            disableConfirmationButtons: action.disableConfirmationButtons,
            selectedTeachers: []
        };
    }
    case actions.UNASSIGN_TEACHERS_FAILURE: {
        return { ...state, disableConfirmationButtons: action.disableConfirmationButtons };
    }
    case actions.OPEN_UNASSIGN_TEACHERS_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType };
    }
    case actions.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL: {
        return { ...state, refreshTeacherList: action.refreshTeacherList, selectedTeachers: action.selectedTeachers };
    }
    case actions.ADD_TEACHER_OPEN_MODAL_REQUEST: {
        return {
            ...state,
            showModal: action.showModal,
            showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
            lastAddedTeacherUserProfileId: 0,
            teacherModel: assignEmptyTeacherObject()
        };
    }
    case actions.ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST: {
        return {
            ...state,
            showModal: action.showModal,
            showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
            teacherModel: assignEmptyTeacherObject()
        };
    }
    case actions.ADD_TEACHER_CLOSE_MODAL_REQUEST:
    {
        return { ...state,
            showModal: action.showModal
        };
    }
    case actions.ADD_TEACHER_REQUEST:
    {
        return { ...state, isSaveInProgress: action.isSaveInProgress };
    }
    case actions.ADD_TEACHER_SUCCESS:
    {
        return {
            ...state,
            isSaveInProgress: false,
            showAddTeacherConfirmationModal: action.showAddTeacherConfirmationModal,
            lastAddedTeacherUserProfileId: action.userProfileId,
            selectedTeachers: []
        };
    }
    case actions.ADD_TEACHER_FAILURE:
    {
        let errorMessage = '';
        if (action.isServerError) {
            errorMessage = messages.errorMessageHeader;
        } else {
            errorMessage = action.addTeacherValidationMessage;
        }
        return {
            ...state,
            isSaveInProgress: false,
            showAddTeacherValidationModal: action.showAddTeacherValidationModal,
            addTeacherValidationMessage: errorMessage };
    }
    case actions.CLOSE_ADD_TEACHER_VALIDATION_MODAL:
    {
        return { ...state, showAddTeacherValidationModal: action.showAddTeacherValidationModal };
    }
    case actions.PRINT_TEACHER_SIGN_IN_CARD_REQUEST: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.PRINT_TEACHER_SIGN_IN_CARD_SUCCESS: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.PRINT_TEACHER_SIGN_IN_CARD_FAILURE: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.OPEN_DELETE_TEACHER_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType };
    }
    case actions.DELETE_TEACHER_REQUEST: {
        return { ...state, deletingTeacher: true, deleteSuccess: false, disableConfirmationButtons: action.disableConfirmationButtons, operationType: action.operationType };
    }
    case actions.DELETE_TEACHER_SUCCESS: {
        return { ...state,
            deletingTeacher: false,
            deleteSuccess: true,
            disableConfirmationButtons: action.disableConfirmationButtons,
            isUserOperationModalOpen: action.isUserOperationModalOpen,
            notDeletedTeachers: action.notDeletedTeachers,
            refreshTeacherList: true,
            selectedTeachers: action.selectedTeachers
        };
    }
    case actions.DELETE_TEACHER_FAILURE: {
        return { ...state, deletingTeacher: false, deleteSuccess: false, disableConfirmationButtons: action.disableConfirmationButtons };
    }
    case QUICK_UPLOAD_CLOSE_MODAL_REQUEST:
    case CANCEL_USER_ASSIGN_REQUEST:
    case ASSIGN_TEACHER_SUCCESS: {
        return { ...state, isTeacherDataLoaded: false, selectedTeachers: [] };
    }

    case RESET_USER_CLASSROOM_RELATION: {
        return { ...state, selectedTeachers: [] };
    }

    case DELETE_CLASSROOMS_SUCCESS:
    case ADD_CLASS_SUCCESS:
    case ADD_STUDENT_SUCCESS:
    case REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST:
    case EDIT_TEACHER_SUCCESS_REQUEST:
    case ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS: {
        return { ...state, refreshTeacherList: true, selectedTeachers: [] };
    }

    case GET_CLASSROOMS_SUCCESS: {
        return {
            ...state,
            dataFilterOption: updateClassroomList(resetFilterOptions(state.dataFilterOption), action.data),
            teacherModel: updateEmptyTeacherModel(action.data)
        };
    }
    case UNASSIGN_TEACHER_SUCCESS: {
        return { ...state, isTeacherDataLoaded: false };
    }
    case actions.SEND_VERIFICATION_EMAIL_SUCCESS:
        return sendVerificationEmailSuccess(state, action.results);
    case actions.SEND_VERIFICATION_EMAIL_FAILURE:
        return sendVerificationEmailFailure(state);
    case actions.CLOSE_EMAIL_VERIFICATION_MODAL:
        return closeVerificationModal(state);
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/teacher-roll/reducer.js